import React from "react";
import classnames from "classnames";

import { CommonProps, getClasses } from "./buttonCommon";
import { replaceClasses } from "../utils/replaceClasses";

export const Button = (
  props: CommonProps & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
) => {
  const { size, kind, iconLeft, iconRight, children, className, classNameOverride, ...p } = props;
  if (kind === "link") {
    return (
      <button
        className={replaceClasses(
          "inline text-blue underline hover:text-info disabled:text-button-disabled-text disabled:cursor-not-allowed",
          classNameOverride
        )}
        {...p}
      >
        {children}
      </button>
    );
  }
  const c = getClasses(size, kind, p.disabled);
  return (
    <button className={replaceClasses(classnames(c.sizeClass, c.kindClass, className), classNameOverride)} {...p}>
      {iconLeft ? iconLeft({ className: c.iconClass }) : null}
      <span className="align-middle">{children}</span>
      {iconRight ? iconRight({ className: c.iconClass }) : null}
    </button>
  );
};
